import React from "react";

export const MagnifyingGlass: React.FC<{ fill?: "filled" | "none" }> = ({
  fill = "none"
}) => {
  if (fill === "filled") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        width="100%"
        height="100%"
      >
        <path
          fill="currentColor"
          d="M168,112a56,56,0,1,1-56-56A56,56,0,0,1,168,112Zm61.66,117.66a8,8,0,0,1-11.32,0l-50.06-50.07a88,88,0,1,1,11.32-11.31l50.06,50.06A8,8,0,0,1,229.66,229.66ZM112,184a72,72,0,1,0-72-72A72.08,72.08,0,0,0,112,184Z"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden={true}
    >
      <path
        fillRule="evenodd"
        d="M5 14.5C5 9.25329 9.25329 5 14.5 5C19.7467 5 24 9.25329 24 14.5C24 17.1171 22.9418 19.487 21.2298 21.2052C21.2256 21.2093 21.2213 21.2135 21.2171 21.2177C21.2129 21.2219 21.2087 21.2261 21.2046 21.2304C19.4865 22.942 17.1168 24 14.5 24C9.25329 24 5 19.7467 5 14.5ZM21.8937 23.3085C19.8946 24.9883 17.3154 26 14.5 26C8.14873 26 3 20.8513 3 14.5C3 8.14873 8.14873 3 14.5 3C20.8513 3 26 8.14873 26 14.5C26 17.3158 24.988 19.8952 23.3079 21.8943L28.7064 27.2928C29.0969 27.6833 29.0969 28.3165 28.7064 28.707C28.3158 29.0975 27.6827 29.0975 27.2922 28.707L21.8937 23.3085Z"
        fill="currentColor"
      />
    </svg>
  );
};
